import React from 'react';
import { useTranslation } from '@/contexts/LanguageContext';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Sparkles, Loader2 } from 'lucide-react';

interface AIPanelProps {
  globalImageStyle: string;
  setGlobalImageStyle: (style: string) => void;
  defaultImageStyle: string;
  globalFeedback: string;
  setGlobalFeedback: (feedback: string) => void;
  isRefining: boolean;
  onGlobalRefine: () => void;
}

const AIPanel: React.FC<AIPanelProps> = ({
  globalImageStyle,
  setGlobalImageStyle,
  defaultImageStyle,
  globalFeedback,
  setGlobalFeedback,
  isRefining,
  onGlobalRefine,
}) => {
  const { t } = useTranslation();

  return (
    <div className="p-3 space-y-3">
      <div className="p-3 bg-secondary rounded-lg">
        <div className="flex items-center justify-between mb-2">
          <Label className="text-sm font-medium">{t('workspace.imageGenerationStyle')}</Label>
          <Button variant="link" size="sm" onClick={() => setGlobalImageStyle(defaultImageStyle)} className="text-xs text-muted-foreground hover:text-foreground p-0 h-auto" title={t('workspace.resetToDefault')}>{t('workspace.reset')}</Button>
        </div>
        <Textarea value={globalImageStyle} onChange={(e) => setGlobalImageStyle(e.target.value)} placeholder={t('workspace.imageStylePlaceholder')} className="w-full h-16 text-xs resize-none" />
        <p className="text-[10px] text-muted-foreground mt-1">{t('workspace.imageStyleAppliedHint')}</p>
      </div>
      <div className="p-3 bg-secondary rounded-lg">
        <Label className="text-sm font-medium mb-2 block">{t('workspace.refineAllWithAI')}</Label>
        <Textarea value={globalFeedback} onChange={(e) => setGlobalFeedback(e.target.value)} placeholder={t('workspace.refineAllPlaceholder')} className="w-full h-16 resize-none mb-2" disabled={isRefining} />
        <Button onClick={onGlobalRefine} disabled={!globalFeedback.trim() || isRefining} className="w-full bg-purple-600 hover:bg-purple-500" size="sm">
          {isRefining ? (<><Loader2 className="animate-spin h-4 w-4 mr-2" />{t('workspace.refining')}</>) : (<><Sparkles className="h-4 w-4 mr-2" />{t('workspace.refineAllSlides')}</>)}
        </Button>
      </div>
    </div>
  );
};

export default AIPanel;
